import _ from 'lodash';
import qs from 'qs';

const defaultDashboardSettings = {
    uiOptions: {
        shouldHideToast: true,
        fields: {
            isAuthOnly: 'hidden',
            classification: 'hidden',
            businessNumber: 'hidden',
            password: 'hidden',
            securityCode: 'optional',
            description: 'optional',
            descriptor: 'hidden',
            invoice: 'optional',
            orderNumber: 'optional',
            customerRef: 'optional',
            firstName: 'optional',
            lastName: 'optional',
            phone: 'optional',
            email: 'optional',
            billToAddressOne: 'optional',
            billToAddressTwo: 'optional',
            billToCity: 'optional',
            billToState: 'optional',
            billToPostal: 'optional',
            billToCountry: 'optional',
            billToPhone: 'optional',
            shipToAddressOne: 'optional',
            shipToAddressTwo: 'optional',
            shipToCity: 'optional',
            shipToState: 'optional',
            shipToPostal: 'optional',
            shipToCountry: 'optional',
            shipToPhone: 'optional',
            birthDate: 'hidden',
            nationalIdentificationNumber: 'hidden'
        }
    },
    processingOptions: {
        saveCardToken: false
    }
};

const initialState = {
    paymentMethod: 'KEYED',
    isActionCompleted: false,
    isActionPending: false,
    actionResultStatus: undefined,
    actionResultData: undefined,
    ...loadInitialState(location.search, location.pathname)
};

export function loadInitialState(queryString, pathname) {
    const params = qs.parse(queryString, { ignoreQueryPrefix: true });

    const simpleLogin = params.simpleLogin;

    const currentPath = pathname !== undefined ? pathname : (typeof location !== 'undefined' ? location.pathname : '');
    const isDashboardRoute = _.startsWith(currentPath, '/dashboard');
    const baseSettings = isDashboardRoute ? defaultDashboardSettings : undefined;

    let settings;
    const rawSettings = params.settings;
    if (rawSettings && typeof rawSettings === 'string') {
        try {
            const urlSettings = JSON.parse(rawSettings);
            settings = baseSettings ? _.merge({}, baseSettings, urlSettings) : urlSettings;
        } catch {
            console.error('unable to parse "settings" json');
            settings = baseSettings;
        }
    } else {
        settings = baseSettings;
    }

    return {
        simpleLogin,
        settings,
        merchantId: _.get(settings, 'uiOptions.merchantIdSet') || _.get(settings, 'uiOptions.merchantIdDefault'),
        currency: _.get(settings, 'data.currency')
    };
}

export const actionTypes = {
    ON_GET_SETTINGS: 'onGetSettings',
    UPDATE_MERCHANT_ID: 'updateMerchantId',
    UPDATE_PAYMENT_METHOD: 'updatePaymentMethod',
    UPDATE_CURRENCY: 'updateCurrency',
    SET_LOADED: 'setLoaded',
    ACTION_PENDING: 'actionPending',
    ACTION_COMPLETED: 'actionCompleted',
    RESET_ACTION: 'resetAction'
};

const eventTypeActionMap = {
    settings: actionTypes.ON_GET_SETTINGS
};

const setupListeners = () => (dispatch) => {
    window.addEventListener('message', (event) => {
        const origin = _.get(event, 'origin');
        const eventType = _.get(event, 'data.event');
        const eventData = _.get(event, 'data.data') || {};

        if (eventType && _.startsWith(document.referrer, origin)) {
            dispatch({
                type: eventTypeActionMap[eventType],
                payload: eventData
            });
        }
    });
};

const updateMerchant = (merchantId) => (dispatch) => {
    dispatch({
        type: actionTypes.UPDATE_MERCHANT_ID,
        payload: merchantId
    });
};

const updatePaymentMethod = (paymentMethod) => (dispatch) => {
    dispatch({
        type: actionTypes.UPDATE_PAYMENT_METHOD,
        payload: paymentMethod
    });
};

const updateCurrency = (currency) => (dispatch) => {
    dispatch({
        type: actionTypes.UPDATE_CURRENCY,
        payload: currency
    });
};

const actionPending = () => (dispatch) => {
    dispatch({ type: actionTypes.ACTION_PENDING });
};

const actionCompleted = (message) => (dispatch) => {
    const payload = _.isString(message)
        ? { message }
        : (message || {});

    dispatch({ type: actionTypes.ACTION_COMPLETED, payload });
};

const resetAction = () => (dispatch) => {
    dispatch({ type: actionTypes.RESET_ACTION });
};

export const actions = {
    setupListeners,
    updateMerchant,
    updatePaymentMethod,
    updateCurrency,
    actionPending,
    actionCompleted,
    resetAction
};

export function reducers(state = initialState, action) {
    switch (action.type) {
        case actionTypes.ON_GET_SETTINGS:
            return {
                ...state,
                settings: action.payload,
                currency: _.get(action.payload, 'data.currency'),
                merchantId: _.get(action.payload, 'uiOptions.merchantIdSet') || _.get(action.payload, 'uiOptions.merchantIdDefault')
            };
        case actionTypes.UPDATE_MERCHANT_ID:
            return {
                ...state,
                merchantId: action.payload
            };
        case actionTypes.UPDATE_PAYMENT_METHOD:
            return {
                ...state,
                paymentMethod: action.payload
            };
        case actionTypes.UPDATE_CURRENCY:
            return {
                ...state,
                currency: action.payload
            };
        case actionTypes.ACTION_PENDING:
            return {
                ...state,
                isActionPending: true,
                isActionCompleted: false,
                actionResultMessage: undefined,
                actionResultStatus: undefined,
                actionResultData: undefined
            };
        case actionTypes.ACTION_COMPLETED:
            return {
                ...state,
                isActionPending: false,
                isActionCompleted: true,
                actionResultMessage: _.isString(action.payload) ? action.payload : _.get(action.payload, 'message'),
                actionResultStatus: _.get(action.payload, 'status'),
                actionResultData: _.get(action.payload, 'data')
            };
        case actionTypes.RESET_ACTION:
            return {
                ...state,
                isActionPending: false,
                isActionCompleted: false,
                actionResultMessage: undefined,
                actionResultStatus: undefined,
                actionResultData: undefined
            };
        default:
            return state;
    }
}
